<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import axios from '../axios';
import store from "../store";

const route = useRoute();
const showModal = ref(false);
const showProceedModel = ref(false);
const errors = ref([]);
const isGetQuote = ref(true);
const fields = ref([{ type: '', size: '', confirm_size: '', weight: '', subBox: null }]);
const addField = () => {
    fields.value.push({ type: '', size: '', confirm_size: '', weight: '', subBox: null });
};

// const addSmaller = ref(false);
const addSubBox = (index) => {
    fields.value[index].subBox = {
        type: '',
        size: '',
        weight: ''
    };
};

const removeSubBox = (index) => {
    fields.value[index].subBox = null;
};


const BoxSize = ref([
    { title: "Select Box Size", value: "" },
    { title: "9x6x3", value: "9x6x3" },
    { title: "12x10x3", value: "12x10x3" },
    { title: "12x12x6", value: "12x12x6" },
    { title: "15x12x10", value: "15x12x10" },
    { title: "16x12x8", value: "16x12x8" },
    { title: "16x16x4", value: "16x16x4" },
    { title: "17x11x8", value: "17x11x8" },
    { title: "17x17x8", value: "17x17x8" },
    { title: "18x14x12", value: "18x14x12" },
    { title: "18x16x14", value: "18x16x14" },
    { title: "20x20x12", value: "20x20x12" },
    { title: "20x16x16", value: "20x16x16" },
    { title: "20x14x6", value: "20x14x6" },
    { title: "20x12x12", value: "20x12x12" },
    { title: "22x18x16", value: "22x18x16" },
    { title: "24x16x12", value: "24x16x12" },
    { title: "24x18x18", value: "24x18x18" },
    { title: "24x24x16", value: "24x24x16" },
    { title: "26x20x8", value: "26x20x8" },
    { title: "26x20x20", value: "26x20x20" },
    { title: "29x24x24", value: "29x24x24" },
    { title: "30x30x16", value: "30x30x16" },
    { title: "28x16x7", value: "28x16x7" },
    { title: "36x20x9", value: "36x20x9" },
    { title: "24x6x6", value: "24x6x6" },
    { title: "36x8x8", value: "36x8x8" },
    { title: "6x6x6", value: "6x6x6" },
    { title: "8x8x8", value: "8x8x8" },
    { title: "10x10x10", value: "10x10x10" },
    { title: "12x12x12", value: "12x12x12" },
    { title: "14x14x14", value: "14x14x14" },
    { title: "16x16x16", value: "16x16x16" },
    { title: "18x18x18", value: "18x18x18" },
    { title: "20x20x20", value: "20x20x20" },
    { title: "22x22x22", value: "22x22x22" },
    { title: "24x24x24", value: "24x24x24" },
    { title: "24x24x24 DW", value: "24x24x24" },
    { title: "26x26x26", value: "26x26x26" },
    { title: "28x28x28", value: "28x28x28" },
    { title: "32x32x32 DW 275", value: "32x32x32" },
    { title: "34x34x34", value: "34x34x34" },
    { title: "36x36x36", value: "36x36x36" },
    { title: "24x6x18 275 lb", value: "24x6x18" },
    { title: "24x18x6", value: "24x18x6" },
    { title: "30x24x6", value: "30x24x6" },
    { title: "30x6x24 275 lb", value: "30x6x24" },
    { title: "36x8x30 275 lb", value: "36x8x30" },
    { title: "36x6x42 275 lb", value: "36x6x42" },
    { title: "40x8x50 275 lb", value: "40x8x50" },
    { title: "54x8x28 275 lb (bicycle)", value: "54x8x28" },
    { title: "48x6x32-72 275 lb (Art Jumbo)", value: "48x6x32" },
    { title: "42x8x60 400 lb Dw", value: "42x8x60" },
    { title: "6x6x48 (Pole)", value: "6x6x48" },

    { title: "10x10x48 (Golf /Umbrella)", value: "10x10x48" },
    { title: "15x15x48 (Golf Bag)", value: "15x15x48" },
    { title: "18x18x28 (Dish Pack)", value: "18x18x28" },
    { title: "20x8x50 (Guitar)", value: "20x8x50" },
    { title: "24x13x31 (suitecase)", value: "24x13x31" },
    { title: "35x22x22 (EH)", value: "35x22x22" },
    { title: "40x18x8 (Laydown)", value: "40x18x8" },
    { title: "54x8x28 275 lb (bicycle)", value: "54x8x28" },

    { title: "9x6x3 (Medium Secruity)", value: "9x6x3" },
    { title: "12x10x3 (Large Security)", value: "12x10x3" },
    { title: "12x12x6 UPS-13", value: "12x12x6" },
    { title: "15x12x10 UPS-21", value: "15x12x10" },
    { title: "16x12x8", value: "16x12x8" },
    { title: "16x16x4 UPS-17", value: "16x16x4" },
    { title: "16x16x8 UPS-31", value: "16x16x8" },
    { title: "17x11x8 UPS-27", value: "17x11x8" },
    { title: "17x17x8 UPS -29", value: "17x17x8" },
    { title: "18x14x12 (1680670 #44)", value: "18x14x12" },
    { title: "20x20x12 UPS-60", value: "20x20x12" },
    { title: "20x12x12 UPS-34", value: "20x12x12" },
    { title: "24x18x18 UPS-46B", value: "24x18x18" },
    { title: "24x24x16 UPS-47B", value: "24x24x16" },
    { title: "17x17x8 Laptop (All-in-one) ", value: "17x17x8" },
    { title: "10x5x3 Cell Phone (All-in-one)", value: "10x5x3" },

]);

const removeField = (index) => {
    if (fields.value.length > 1) fields.value.splice(index, 1);
};

const showPrizeCard = ref(false);

const prizes = ref([
    { label: ' Next Day Air:', value: '0', code: '', insurance: '', signature: '', baseServiceCharge: 0.00, allCharges: [] },
    { label: ' Second Day:', value: '0', code: '', insurance: '', signature: '', baseServiceCharge: 0.00, allCharges: [] },
    { label: ' Third Day:', value: '0', code: '', insurance: '', signature: '', baseServiceCharge: 0.00, allCharges: [] },
    { label: ' Ground Shipping:', value: '0', code: '', insurance: '', signature: '', baseServiceCharge: 0.00, allCharges: [] }
]);

const isPrice = ref(false);
const isMail = ref(false);
const qoutationItems = ref([]);
const qoutationData = ref('');
const boxCost = ref(0);
const packagingCost = ref(0);
const pickupCharge = ref(0);
const shippingCost = ref(0);
const signatureCost = ref(0);
const insuranceCost = ref(0);
const selectedShippingCode = ref('');
const boxesCount = ref([]);
const insurance_per_box = ref(0);
// const allCharges = ref([]);
const cms_processing_fee = ref(0);
const amount_exceeds_limit = ref(false);
const max_tier_value = ref(0);
const totalCost = computed(() => {
    return parseFloat(boxCost.value) + parseFloat(packagingCost.value) + parseFloat(pickupCharge.value == '' ? 0 : pickupCharge.value) + parseFloat(shippingCost.value) + parseFloat(signatureCost.value) + parseFloat(insuranceCost.value) + parseFloat(cms_processing_fee.value);
});


// function parseSize(str) {
//   const [l, w, h] = str.split('x').map(Number);
//   return { l, w, h, volume: l * w * h };
// }

// function isSmaller(child, parent) {
//   if (!child || !parent) return false;

//   const c = parseSize(child);
//   const p = parseSize(parent);

//   return c.l <= p.l && c.w <= p.w && c.h <= p.h && c.volume < p.volume;
// }

// const getValidSubBoxOptions = (parentSize) => {
//   return BoxSize.value.filter(box => {
//     return box.value !== parentSize && isSmaller(box.value, parentSize);
//   });
// };



const isConfirmSizeValid = (str) => {
    const pattern = /^(\d+)x(\d+)x(\d+)$/;
    return pattern.test(str.trim());
};

// Called on input to filter allowed characters (optional, but useful)
const onConfirmSizeInput = (field) => {
    // Filter input to allow only digits and 'x'
    field.confirm_size = field.confirm_size.toLowerCase().replace(/[^0-9x]/g, '');
};

// Clean and standardize confirm_size input
const normalizeSizeInput = (size) => {
    return size
        .toLowerCase()
        .replace(/[^0-9x]/g, '')     // keep only digits and 'x'
        .replace(/x{2,}/g, 'x')      // collapse multiple x to one
        .trim();                     // trim spaces only
};


const submit = () => {
    if (amount_exceeds_limit.value) {
        store.commit('setErrorNotification', `Amount exceeds maximum allowed insurance tier limit of $${Number(max_tier_value.value).toFixed(2)}`);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 7000);
        return;
    }
    errors.value = [];
    fields.value.forEach((field, index) => {

        if (field.confirm_size) {
            field.confirm_size = normalizeSizeInput(field.confirm_size);
        }

        const hasValidConfirmSize = field.confirm_size && isConfirmSizeValid(field.confirm_size);
        if (!field.type || !field.size || !field.weight) {
            errors.value.push(`Box ${index + 1}: Type and Size and Weight must be selected.`);
            store.commit('setErrorNotification', `Box ${index + 1}: Type and Size and Weight must be selected.`);
        }
        if (field.confirm_size && !hasValidConfirmSize) {
            errors.value.push(`Box ${index + 1}: Confirm Box Size format is invalid.`);
            store.commit('setErrorNotification', `Box ${index + 1}: Confirm Box Size format is invalid.`);
        }
        if (field?.subBox != null && (field?.subBox.type === '' || field?.subBox.size === '')) {
            errors.value.push(`Sub Box ${index + 1}: Sub Box Type and Size  must be selected.`);
            store.commit('setErrorNotification', `Sub Box ${index + 1}: Sub Box Type and Size must be selected.`);
        }
        // if(field?.subBox != null){
        //     errors.value.push(`Sub Box ${index + 1}: Sub Box Size must be selected.`);
        //     store.commit('setErrorNotification', `Sub Box ${index + 1}: Sub Box Size must be selected.`);
        // }
        // if(field.subBox && field.subBox.weight && isNaN(field.subBox.weight)){
        //     errors.value.push(`Sub Box ${index + 1}: Sub Box Weight must be a number.`);
        //     store.commit('setErrorNotification', `Sub Box ${index + 1}: Sub Box Weight must be a number.`);
        // }
        if (isNaN(field.weight)) {
            errors.value.push(`Box ${index + 1}: Weight must be a number.`);
            store.commit('setErrorNotification', `Box ${index + 1}: Weight must be a number.`);
        }
        if (field.weight && field.weight <= 0) {
            errors.value.push(`Box ${index + 1}: Weight must be greater than zero.`);
            store.commit('setErrorNotification', `Box ${index + 1}: Weight must be greater than zero.`);
        }
        // if (field.subBox && field.subBox.weight && field.subBox.weight <= 0) {
        //     errors.value.push(`Sub Box ${index + 1}: Sub Box Weight must be greater than zero.`);
        //     store.commit('setErrorNotification', `Sub Box ${index + 1}: Sub Box Weight must be greater than zero.`);
        // }
    });
    setTimeout(() => {
        store.commit('clearNotifications');
    }, 7000);
    if (errors.value.length > 0) {
        return;
    }
    isPrice.value = true;
    axios.post("api/addBoxes", { id: decodeURIComponent(atob(route.params.id)), boxes: fields.value, pickupCharge: pickupCharge.value === '' ? 0 : pickupCharge.value }).then((response) => {
        console.log('check:', response.data);
        getSingleQuote();
        shippingCost.value = 0;
        showPrizeCard.value = true;
        store.commit('setSuccessNotification', "Price fetched successfully");
        store.commit('setErrorNotification', null);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 7000);
        isPrice.value = false;
        // showModal.value = false;
    }).catch((error) => {
        isPrice.value = false;
        showPrizeCard.value = false;
        if (error.response?.data && error.response?.data.error) {
            store.commit('setErrorNotification', error.response.data.error);
            store.commit('setSuccessNotification', null);
        }
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 7000);
        console.error(error);
    });
};


const getSingleQuote = () => {
    axios.post("api/get-single-quote", { id: decodeURIComponent(atob(route.params.id)) }).then((response) => {
        console.log(response.data);
        insurance_per_box.value = response.data.insurance_per_box || 0;
        console.log("Insurance Per Box:", insurance_per_box.value);
        amount_exceeds_limit.value = response.data.amount_exceeds_limit || false;
        max_tier_value.value = response.data.max_tier_value || 0;

        qoutationData.value = response.data?.quote;
        if (response.data.quote?.shipping_option != null && response.data.quote?.shipping_option != 0) {
            shippingCost.value = response.data.quote?.shipping_option;
        } else {
            shippingCost.value = 0;
        }
        cms_processing_fee.value = response.data.config?.cms_fee || 0;
        // pickupCharge.value = response.data.config?.pickup_charge || 0;
        if (response.data.quote.is_shipping_option_code != null) {
            selectedShippingCode.value = response.data.quote.is_shipping_option_code;
        }
        if (response.data.quote?.pickupCharge) {
            pickupCharge.value = response.data.quote?.pickupCharge || 0;
        }
        if (response.data.quote?.signatureCost != null && response.data.quote?.signatureCost != 0) {
            signatureCost.value = response.data.quote.signatureCost
        }
        if (response.data.quote?.insuranceCost != null && response.data.quote?.insuranceCost.toString() !== "0") {
            insuranceCost.value = response.data.quote.insuranceCost
        }
        qoutationItems.value = response.data.quote?.items;
        boxesCount.value = response.data?.boxes || [];
        if (response.data.boxes != null && response.data.boxes.length > 0) {
            fields.value = response.data.boxes.map(item => ({
                type: item.type,
                size: item.size,
                confirm_size: item.confirm_size,
                weight: item.weight,
                subBox: item.subBox ? { type: item.subBox.type, size: item.subBox.size, weight: item.subBox.weight } : null
            }));
            boxCost.value = response.data.total_box_price;
            packagingCost.value = response.data.total_packaging_cost;
            showModal.value = true;
            showPrizeCard.value = true;

        } else {
            showPrizeCard.value = false;
        }
        isGetQuote.value = false;
        // if (response.data.shippingRates?.length > 0) {
        //     prizes.value = response.data.shippingRates.map((item) => {
        //         return { label: item.Service, value: item.Rate, code: item.Code, insurance: item.InsurancePrice, signature: item.SignaturePrice, baseServiceCharge: item.BaseServiceCharge, allCharges: item.AllCharges || [] };
        //     });
        // }
         if (response.data.shippingRates?.length > 0) {
                    prizes.value = response.data.shippingRates.map((item) => {
                        return {
                            label: item.Service,
                            value: item.Rate,
                            code: item.Code,
                            insurance: item.InsurancePrice,
                            signature: item.SignaturePrice,
                            baseServiceCharge: item.BaseServiceCharge,
                            allCharges: item.AllCharges || []
                        };
                    });
        
                    // insurance sync
                    if (parseFloat(insuranceCost.value) > 0 && selectedShippingCode.value) {
                        const selectedPrize = prizes.value.find(p => parseInt(p.code) === parseInt(selectedShippingCode.value));
        
                        if (selectedPrize && parseFloat(selectedPrize.insurance) !== parseFloat(insuranceCost.value)) {
                            insuranceCost.value = selectedPrize.insurance;
        
                            axios.post("api/selectInsurance", {
                                id: decodeURIComponent(atob(route.params.id)),
                                price: selectedPrize.insurance
                            }).catch((error) => { console.error("Error syncing insurance:", error); });
                        }
                    }
        
                    // signature sync
                    if (parseFloat(signatureCost.value) > 0 && selectedShippingCode.value) {
                        const selectedPrize = prizes.value.find(p => parseInt(p.code) === parseInt(selectedShippingCode.value));
        
                        if (selectedPrize && parseFloat(selectedPrize.signature) !== parseFloat(signatureCost.value)) {
                            signatureCost.value = selectedPrize.signature;
        
                            axios.post("api/selectSignature", {
                                id: decodeURIComponent(atob(route.params.id)),
                                price: selectedPrize.signature
                            }).catch((error) => { console.error("Error syncing signature:", error); });
                        }
                    }
                }
    }).catch((error) => {
        isGetQuote.value = false;
        console.error(error);
    });
}

const selectPrice = (price, code) => {
    isGetQuote.value = true;
    insuranceCost.value = 0;
    signatureCost.value = 0;
    axios.post("api/selectPrice", { id: decodeURIComponent(atob(route.params.id)), price: price, code: code }).then((res) => {
        shippingCost.value = price;
        selectedShippingCode.value = code;
        isGetQuote.value = false;
        console.log(res.data)
    })
}

const selectSignature = (price, signCost) => {
    const signaturePrice = signCost == 0 ? price : 0;
    signatureCost.value = signaturePrice;
    axios.post("api/selectSignature", { id: decodeURIComponent(atob(route.params.id)), price: signaturePrice }).then((res) => {
        console.log(res.data);
    })
}
const selectInsurance = (price, insCost) => {
    console.log(price, insCost);
    const insurancePrice = insCost.toString() === "0" ? price : 0;
    insuranceCost.value = insurancePrice;
    axios.post("api/selectInsurance", { id: decodeURIComponent(atob(route.params.id)), price: insurancePrice }).then((res) => {
        console.log(res.data);
    })
}

const validatePickupCharge = (event) => {
    let val = event.target.value;
    if (val.includes('.')) {
        const parts = val.split('.');
        if (parts[1].length > 2) {
            val = parts[0] + '.' + parts[1].slice(0, 2);
            event.target.value = val;
            pickupCharge.value = val;
        }
    }
    const numValue = Number(val);
    if (isNaN(numValue) || numValue < 0) {
        pickupCharge.value = 0;
    }
}

//dynamically calculate signature cost based on selected shipping option
const signatureUnitPrice = computed(() => {
    const selected = prizes.value.find(
        p => parseInt(p.code) === parseInt(selectedShippingCode.value)
    );

    return selected ? Number(selected.signature || 0).toFixed(2) : "0.00";
});

const submitMail = () => {
    // if (confirm("Are you sure you want to send the email?")) {
    isMail.value = true;
    if (shippingCost.value <= 0) {
        showProceedModel.value = false;
        store.commit('setErrorNotification', "Please select a shipping option before sending the email.");
        store.commit('setSuccessNotification', null);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 3000);
        isMail.value = false;
        return;
    }
    axios.post("api/sendQuotationMail", { id: decodeURIComponent(atob(route.params.id)), shippingRates: prizes.value, pickupCharge: pickupCharge.value == '' ? 0 : pickupCharge.value }).then((res) => {
        console.log(res.data)
        showProceedModel.value = false;
        store.commit('setSuccessNotification', "Email sent successfully");
        store.commit('setErrorNotification', null);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 3000);
        isMail.value = false;
    }).catch((error) => {
        isMail.value = false;
        showProceedModel.value = false;
        if (error.response?.data && error.response?.data.error) {
            store.commit('setErrorNotification', error.response.data.error);
            store.commit('setSuccessNotification', null);
        }
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 3000);
        console.error(error);
    });
    // }
};

onMounted(() => {
    getSingleQuote();
});
</script>

<template>
    <div class="py-4 container-fluid ctm-mobile-padding">
        <div class="row mt-4">
            <!-- <button class="upload-btn" @click="openModal">Add New Quotation </button>  -->
            <div class="col-lg-12 mb-lg-0 mb-4">
                <div class="card p-3 p-md-5 shadow-lg rounded-xl bg-light-color text-gray-800 position-relative">
                    <div class="ctm-loader" v-if="isMail || isPrice || isGetQuote">
                        <div class="loader" id="loader-5">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <!-- Header -->
                    <div class="d-flex justify-space-between align-items-center mb-2">
                        <h2 class="text-2xl font-bold box-heading">Quotation</h2>
                    </div>
                    <div class="d-flex justify-content-between align-items-center pb-2 mb-3">
                        <div>
                            <p class="text-sm text-gray-500 mb-1"><strong>Quotation No:</strong>
                                {{ qoutationData.quotation_number }}</p>
                            <p class="text-sm text-gray-500 mb-1"><strong>Date:</strong> {{ qoutationData.shipment_date
                                }}</p>
                            <p class="text-sm text-gray-500 mb-1"><strong>Customer Name:</strong> {{
                                qoutationData.customer_name }}</p>
                            <p class="text-sm text-gray-500 mb-1"><strong>Ship To:</strong>
                                {{ qoutationData.ship_to_address }},{{ qoutationData.ship_to_cityzip }} {{
                                    qoutationData.ship_to_country }}</p>
                            <p class="text-sm text-gray-500 mb-1"><strong>Phone No:</strong> {{
                                qoutationData.customer_phone }}</p>
                            <p class="text-sm text-gray-500 mb-1"><strong>Email:</strong> {{
                                qoutationData.customer_email
                                }}</p>
                        </div>
                    </div>

                    <!-- Auction Summary -->
                    <div class="auction-content d-flex justify-content-between align-items-center mb-4">
                        <button @click="showModal = !showModal" class="open-btn" :disabled="showPrizeCard"
                            :class="showPrizeCard ? 'bg-light-color' : ''"
                            :style="showPrizeCard ? 'cursor: default;' : ''">
                            {{ showModal ? 'Add Boxes' : 'Add Boxes' }}
                        </button>
                    </div>

                    <!-- Table -->
                    <div class="overflow-x-auto table-overflow">
                        <table class="border border-gray-300 w-100">
                            <thead class="bg-gray-100">
                                <tr>
                                    <th class="p-3 text-left">Lot No</th>
                                    <th class="p-3 text-left">Item Name</th>
                                    <th class="p-3 text-left">Size</th>
                                    <th class="p-3 text-left">Quantity</th>
                                    <th class="p-3 text-left">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in qoutationItems" :key="index"
                                    class="border-t border-gray-200">
                                    <td class="p-3">{{ item.lot_number }}</td>
                                    <td class="p-3">{{ item.item_name }}</td>
                                    <td class="p-3">{{ item.dimensions }}</td>
                                    <td class="p-3">{{ item.quantity }}</td>
                                    <td class="p-3">${{ item.lot_price }}</td>
                                </tr>
                                <tr class="bg-gray-50 font-semibold">
                                    <td colspan="3"></td>
                                    <td class="p-3"><strong>Total</strong></td>
                                    <td class="p-3"><strong>${{ qoutationData.total }}</strong></td>
                                    <td colspan="3"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>




                </div>
                <div class="row">
                    <div class="col-md-12">
                        <!-- Modal -->
                        <div v-if="showModal" class="card h-100 p-4 rounded-xl mt-4 bg-dark-yellow bg-gray-50">
                            <h3 class="text-xl font-semibold text-[#7b5540] mb-4 box-heading">Add Boxes</h3>
                            <!-- <div v-if="errors.length" class="error-messages mb-2">
                                <ul>
                                    <li v-for="(err, i) in errors" :key="i" class="text-danger text-sm">
                                        {{ err }}
                                    </li>
                                </ul>
                            </div> -->
                            <!-- Box Fields -->
                            <div v-for="(field, index) in fields" :key="index"
                                class="border border-white p-4 rounded mb-3">
                                <!-- Box Type -->
                                <div class="row w-100">
                                    <div class="col-md-3">
                                        <label for="weight">Packaging Type</label>
                                        <select v-model="field.type" class="input">
                                            <option disabled value="">Select Packaging Type</option>
                                            <option>Standard</option>
                                            <option>Fragile</option>
                                            <option>Custom</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="weight">Box Size</label>
                                        <select v-model="field.size" class="input">
                                            <option v-for="(boxes, index) in BoxSize" :key="index" :value="boxes.value"
                                                :disabled="boxes.value === ''">
                                                {{ boxes.title }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="weight">Confirm Box Size</label>
                                        <input id="boxSizeInput" type="text" v-model="field.confirm_size"
                                            @input="onConfirmSizeInput(field)" placeholder="e.g. 9x6x3" maxlength="20"
                                            class="input" />
                                    </div>
                                    <div class="col-md-3"><label for="weight">Enter weight (LBS):</label>
                                        <input type="text" id="weight" min="0" name="weight" v-model="field.weight"
                                            placeholder="e.g., 65"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')" class="input" />
                                    </div>
                                    <div class="col-md-3 d-flex align-items-end">
                                        <div class="d-flex align-items-end gap-2">
                                            <!-- Individual Remove -->
                                            <button v-if="fields.length > 1" @click="removeField(index)"
                                                class="remove-input ml-2">X</button>

                                            <!-- Add Sub-Box Button -->
                                            <div v-if="!field.subBox" class="">
                                                <button @click="addSubBox(index)" class="btn btn-secondary mb-0">Add
                                                    Sub-Box</button>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                                <div v-if="field.subBox" class="row mt-2 mb-3 p-4 border px-2 bg-white mx-1">
                                    <div class="col-md-5">
                                        <label for="weight">Packaging Type</label>
                                        <select v-model="field.subBox.type" class="input">
                                            <option disabled value="">Select Packaging Type</option>
                                            <option>Standard</option>
                                            <option>Fragile</option>
                                            <option>Custom</option>
                                        </select>
                                    </div>
                                    <div class="col-md-5">
                                        <label>Sub Box Size</label>
                                        <select v-model="field.subBox.size" class="input" :disabled="!field.size">
                                            <option v-for="(boxes, index) in BoxSize" :key="index" :value="boxes.value"
                                                :disabled="boxes.value === ''">{{ boxes.title }}</option>
                                            <!-- <option v-for="(box, i) in getValidSubBoxOptions(field.size)" :key="i" :value="box.value" >{{ box.title }}</option> -->
                                        </select>
                                    </div>
                                    <!-- <div class="col-md-3">
                                        <label>Sub Box Weight (LBS)</label>
                                        <input type="text" v-model="field.subBox.weight" placeholder="e.g., 10"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')" class="input" />
                                    </div> -->
                                    <div class="col d-flex align-items-end">
                                        <button @click="removeSubBox(index)" class="remove-input mt-2">X</button>
                                    </div>
                                </div>



                                <!-- Sub-Box (shown only if checkbox is checked) -->
                                <!-- <div v-if="field.subBox" class="row w-100 mt-3 ml-3">
                                    <div class="col-md-4">
                                    <label>Sub Box Size</label>
                                    <select v-model="field.subBox.size" class="input">
                                        <option v-for="(boxes, i) in BoxSize" :key="i" :value="boxes.value">{{ boxes.title }}</option>
                                    </select>
                                    </div>
                                    <div class="col-md-4">
                                    <label>Sub Box Weight (LBS)</label>
                                    <input type="text" v-model="field.subBox.weight" placeholder="e.g., 10"
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '')" class="input" />
                                    </div>
                                </div> -->



                            </div>
                            <div class="plus-group mt-4">
                                <button @click="addField" class="add-btn">Add More</button>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="chargeDesign">
                                        <h5>PickUp Charges</h5>
                                        <input min="0" step="0.01" type="number" placeholder="Enter Pickup charge"
                                            v-model="pickupCharge" @input="validatePickupCharge">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <!-- Actions -->
                                    <div class="modal-actions">
                                        <!-- <button class="" @click="submit">Save</button> -->
                                        <button @click="submit" :disabled="isPrice">{{ isPrice ? "Get Price..." : "Get Price"}}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <div class="row mt-4 mb-4">
                    <div class="col-md-12">
                        <!-- New Prize Card (visible when button clicked) -->
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <div v-if="showPrizeCard"
                                    class="card h-100 p-4 shadow-lg rounded-xl bg-yellow border border-yellow-300 mt-4">
                                    <h3 class="font-semibold text-yellow-800 mb-3 box-heading">UPS Shipping Options
                                        Price</h3>
                                    <div v-for="(prize, index) in prizes" :key="index"
                                        class="flex items-center gap-3 mb-2">
                                        <div v-if="prize.value === '0'">
                                            <input type="radio" :id="'prize' + index" :value="prize.value"
                                                class="cursor-pointer" :disabled="true"
                                                :checked="shippingCost === prize.value && prize.value !== '0'" />
                                            <label :for="'prize' + index" class="text-gray-700">{{ prize.label }} - ${{
                                                prize.value
                                                }}</label>
                                        </div>
                                        <div v-else>
                                            <input type="radio" :id="'prize' + index" :value="prize.value"
                                                :checked="parseFloat(shippingCost) === parseFloat(prize.value) && parseInt(prize.code) == parseInt(selectedShippingCode)"
                                                class="cursor-pointer" @click="selectPrice(prize.value, prize.code)" />
                                            <label :for="'prize' + index" class="text-gray-700">{{ prize.label }} - ${{
                                                prize.value
                                                }}</label>
                                        </div>
                                        <div v-if="parseFloat(shippingCost) === parseFloat(prize.value) && parseInt(prize.code) == parseInt(selectedShippingCode)"
                                            class="cardOuter">
                                            <div class="card cardBackDesign shadow-none">
                                                <label :for="'prize' + index" class="text-gray-700">Charges
                                                    Include</label>
                                                <div class="card-body p-3">
                                                    <label :for="'prize' + index" class="text-gray-700">Base Service
                                                        Charge - ${{ prize.baseServiceCharge }}</label>
                                                    <div v-for="(charge, index) in prize.allCharges" :key="index"
                                                        class="text-gray-600 text-sm">
                                                        <div>
                                                            <span class="font-medium">{{ charge.description }}:</span>
                                                            <span v-if="['100'].includes(charge.code)">${{
                                                                parseFloat(charge.adjusted_amount ?? 0).toFixed(2)
                                                                }}</span>
                                                            <span
                                                                v-else-if="['270', '190', '376'].includes(charge.code)">${{
                                                                parseFloat(charge.adjusted_amount ?? 0).toFixed(2)
                                                                }}</span>
                                                            <span v-else>${{ parseFloat(charge.amount).toFixed(2)
                                                                }}</span>
                                                        </div>

                                                        <template v-if="['100'].includes(charge.code)">
                                                            <div class="ml-4 text-xs text-primary italic">
                                                                → Margin for Additional Handling: ${{ charge.amount }} /
                                                                0.70
                                                            </div>
                                                        </template>

                                                        <template
                                                            v-else-if="['270', '190', '376'].includes(charge.code)">
                                                            <div class="ml-4 text-xs text-primary italic">
                                                                → Margin for Res Surcharge: ${{ charge.amount }} / 0.55
                                                            </div>
                                                        </template>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="parseFloat(shippingCost) === parseFloat(prize.value) && parseInt(prize.code) == parseInt(selectedShippingCode)"
                                            class="cardOuter">
                                            <div class="card cardBackDesign shadow-none">
                                                <label :for="'prize' + index" class="text-gray-700">Charges
                                                    Exclude</label>
                                                <div class="card-body p-3">
                                                    <div>
                                                        <input type="radio" :id="'insurance' + index"
                                                            :value="prize.insurance" v-model="insuranceCost"
                                                            class="cursor-pointer"
                                                            @click="selectInsurance(prize.insurance, insuranceCost)" />
                                                        <label :for="'insurance' + index"
                                                            class="text-gray-700">Insurance - ${{
                                                                parseFloat(prize.insurance).toFixed(2)
                                                            }}</label>
                                                        <!-- <div v-if="parseFloat(prize.insurance) > 0"
                                                            class="ml-4 text-xs text-primary italic">
                                                            → Based on $2.50 per $100 (excluding first $100 of lot
                                                            value)
                                                        </div> -->
                                                        <div v-if="parseFloat(prize.insurance) > 0"
                                                            class="ml-4 text-xs text-primary italic">
                                                           
                                                            → Based on  ${{ insurance_per_box ? parseFloat(insurance_per_box).toFixed(2) : '0.00' }} per $100 (excluding first $100 of lot value)
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <input type="radio" :id="'signature' + index"
                                                            :value="prize.signature" v-model="signatureCost"
                                                            class="cursor-pointer"
                                                            @click="selectSignature(prize.signature, signatureCost)" />
                                                        <label :for="'signature' + index"
                                                            class="text-gray-700">Signature - ${{
                                                                parseFloat(prize.signature).toFixed(2)
                                                            }}</label>
                                                          <!-- <div v-if="parseFloat(prize.signature) > 0" class="ml-4 text-xs text-primary italic">
                                                             → {{ qoutationData.ship_to_country == 'US' ? '$7.70' :
                                                             '$15.40' }} per box × {{ boxesCount.length }}
                                                             box<span v-if="boxesCount.length > 1">es</span>
                                                         </div> -->
                                                        <div v-if="parseFloat(prize.signature) > 0" class="ml-4 text-xs text-primary italic">
                                                             →  ${{ signatureUnitPrice }} per box × {{ boxesCount.length }} box<span v-if="boxesCount.length > 1">es</span> 
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="my-2 text-green-800 font-medium" v-if="selectedPrize">
                                You selected: <strong>{{ selectedPrize }}</strong>
                            </div> -->
                                    <!-- <div class="send-mail mt-2">
                                <button @click="showPrizeCard = true">Send Email</button>
                            </div> -->
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <div v-if="showPrizeCard"
                                    class="card h-100 p-4 shadow-lg rounded-xl bg-yellow border border-yellow-300 mt-4">
                                    <h3 class="font-semibold text-yellow-800 mb-3 box-heading">Shipping Summary</h3>
                                    <table style="background-color: transparent;" class="shipping-table">
                                        <tr>
                                            <td>Shipping Cost</td>
                                            <td style="text-align:right;"><strong>${{
                                                parseFloat(shippingCost).toFixed(2) }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Signature Cost</td>
                                            <td style="text-align:right;"><strong>${{
                                                parseFloat(signatureCost).toFixed(2) }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Insurance Cost</td>
                                            <td style="text-align:right;"><strong>${{
                                                parseFloat(insuranceCost).toFixed(2) }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Packaging Cost</td>
                                            <td style="text-align:right;"><strong>${{
                                                parseFloat(packagingCost).toFixed(2) }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>Box Cost</td>
                                            <td style="text-align:right;"><strong>${{ parseFloat(boxCost).toFixed(2)
                                            }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td>PickUp Charges</td>
                                            <td style="text-align:right;">
                                                <strong>${{ parseFloat(pickupCharge || 0).toFixed(2)
                                                }}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>CMS Processing Fee</td>
                                            <td style="text-align:right;">
                                                <strong>${{ parseFloat(cms_processing_fee).toFixed(2) }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td class="total"><strong>Total Price</strong></td>
                                            <td class="total" style="text-align:right;"><strong>${{
                                                parseFloat(totalCost).toFixed(2)
                                                    }}</strong>
                                            </td>
                                        </tr>
                                    </table>


                                    <div class="send-mail mt-2">
                                        <button @click="showProceedModel = true" :disabled="isMail">{{ isMail ? "Confirm and Proceed..." : "Confirm and Proceed"}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>


    <div v-if="showProceedModel" class="modal-overlay">
        <div class="modal-container">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button class="close-button" @click="showProceedModel = false">&times;</button>
            </div>
            <div class="modal-body">
                <p class="mb-0">are you sure you want to send a quotation mail to customer ?</p>
            </div>
            <div class="modal-footer">
                <button class="btn btn-bg-yellow" @click="showProceedModel = false">No</button>
                <button class="btn btn-bg" @click="submitMail">Yes</button>
            </div>
        </div>
    </div>



</template>


<style scoped>
.cardOuter .card.cardBackDesign {
    background: #ffffffba !important;
    margin-bottom: 20px !important;
}

.card.cardBackDesign label {
    font-size: 14px !important;
}

.card {
    margin: auto;
    box-shadow: 0 8px 26px -4px rgba(0, 0, 0, 0.08);
    background-color: #F2E5D7 !important;
    position: relative;
}

table {
    border-collapse: separate;
    border-radius: 10px;
    background-color: #fff;
}

.field-group {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.input {
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.input:focus,
input:focus {
    outline: none;
}

.open-btn,
.modal-actions button {
    background: #a35c2e !important;
    border: none;
    color: #fff;
    border-radius: 5px;
    padding: 8px 30px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
}

.modal-actions {
    display: flex;
    margin-top: 20px;
    gap: 10px;
    justify-content: end;
}

.plus-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.add-btn,
.remove-input {
    background: #a35c2e !important;
    color: #fff;
    padding: 8px 15px;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 600;
}

th {
    font-size: 16px;
    color: #000;
    font-weight: 600;
}

.auction-content h2,
.box-heading {
    font-size: 22px;
    color: #5D4037;
}

td {
    font-size: 15px;
}

.send-mail button {
    background: #a35c2e !important;
    border: none;
    color: #fff;
    border-radius: 5px;
    padding: 8px 30px;
    cursor: pointer;
    font-weight: 600;
    width: 100%;
    margin-top: 15px;
}

.bg-yellow {
    background-color: #f4e48f;
}

.bg-dark-yellow {
    background-color: #fff3ce;
}

.bg-light-color {
    background-color: #f7f7f9;
}

label,
.form-label {
    font-size: 16px;
    color: #000;
}

input[type="radio" i] {
    width: 25px;
    height: 15px;
}

.add-btn {
    position: absolute;
    top: 23px;
}

.input,
input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 5px;
}


/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

.modal-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    margin-top: 10px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    border-top: none !important;
}

.close-button {
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
}

.chargeDesign h5 {
    font-size: 13px;
}



.chargeDesign input {
    padding: 5px 10px;
    /* 200px: !; */
    width: 138px;
    border-radius: 5px;
}
</style>
